import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Animations, Classes, Events } from '../global/constants';

// ---------- Init Base Animation ----------

export const initBaseAnimations = () => {

	// ---------- Animations ----------

	Animations.mobile.min.push(() => {

		$('.header-wrapper').on('mouseenter', function() {
			this.classList.add(Classes.menuOpen);
			// console.log('in');
		});

		$('.header-wrapper').on('mouseleave', function() {
			this.classList.remove(Classes.menuOpen);
			// console.log('out');
		});
	});
};

$Elements.document.on(Events.page.enter, () => initBaseAnimations());
